import theme from '@theme-ui/preset-tailwind';

export const zIndices = {
  ...(theme.zIndices && theme.zIndices),
};
